import React from 'react';
import { Outlet, Routes, Route } from 'react-router-dom';
import AdminPage from './AdminPage';
import Orders from './Orders/Orders';
import Emails from './Emails/Emails';
import ClientAdminPropertiesPage from './ClientAdminProperties';

const Admin: React.FC = () => {

    return (
        <div style={{ padding: '24px' }}>
            <Routes>
                <Route path="/" element={<AdminPage />} />
                <Route path="/orders" element={<Orders />} />
                <Route path="/emails" element={<Emails />} />
                <Route path="/client-properties" element={<ClientAdminPropertiesPage />} />
            </Routes>
            <Outlet />
        </div>
    );
};

export default Admin;